// mutations
const SCHOOLROUTES_VEHICLES_ALL = (state, schoolroutesVehicles) => {
  if (schoolroutesVehicles.code === 1) {
    state.schoolroutesVehicles = schoolroutesVehicles.data
    state.status = 'success'
  } else {
    alert(schoolroutesVehicles.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_VEHICLES_FORM = (state, schoolroutesVehicles) => {
  if (schoolroutesVehicles.code === 1) {
    state.schoolroutesVehicles = schoolroutesVehicles.data
    state.status = 'success'
  } else {
    alert(schoolroutesVehicles.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_VEHICLES_SHOW = (state, schoolroutesVehicles) => {
  if (schoolroutesVehicles.code === 1) {
    state.schoolroutesVehicles = schoolroutesVehicles.data
    state.status = 'success'
  } else {
    alert(schoolroutesVehicles.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_VEHICLES_CREATE = (state, schoolroutesVehicles) => {
  if (schoolroutesVehicles.code === 1) {
    state.schoolroutesVehicles = schoolroutesVehicles.data
    state.status = 'success'
  } else {
    alert(schoolroutesVehicles.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_VEHICLES_UPDATE = (state, schoolroutesVehicles) => {
  if (schoolroutesVehicles.code === 1) {
    state.schoolroutesVehicles = schoolroutesVehicles.data
    state.status = 'success'
  } else {
    alert(schoolroutesVehicles.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_VEHICLES_DELETE = (state, schoolroutesVehicles) => {
  if (schoolroutesVehicles.code === 1) {
    state.schoolroutesVehicles = schoolroutesVehicles.data
    state.status = 'success'
  } else {
    alert(schoolroutesVehicles.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_VEHICLES_PERMISS_LIST = (state, schoolroutesVehicles) => {
  if (schoolroutesVehicles.code === 1) {
    state.schoolroutesVehicles = schoolroutesVehicles.data
    state.status = 'success'
  } else {
    alert(schoolroutesVehicles.message)
    state.status = 'error'
  }
}
const SCHOOLROUTES_VEHICLES_LIST_CREAR = (state, listpermiss) => {
  if (listpermiss.code === 1) {
    state.schoolroutesVehicles = listpermiss.data
    state.status = 'success'
  } else {
    alert(listpermiss.message)
    state.status = 'error'
  }
}
const SCHOOLROUTES_VEHICLES_LIST_ACTUALIZA = (state, listpermiss) => {
  if (listpermiss.code === 1) {
    state.schoolroutesVehicles = listpermiss.data
    state.status = 'success'
  } else {
    alert(listpermiss.message)
    state.status = 'error'
  }
}
const SCHOOLROUTES_VEHICLES_LIST_BUSCAR = (state, listpermiss) => {
  if (listpermiss.code === 1) {
    state.schoolroutesVehicles = listpermiss.data
    state.status = 'success'
  } else {
    alert(listpermiss.message)
    state.status = 'error'
  }
}

const SCHOOLROUTERS_VEHICLES_ALL = (state, schoolroutesVehicles) => {
  if (schoolroutesVehicles.code === 1) {
    state.schoolroutesVehicles = schoolroutesVehicles.data
    state.status = 'success'
  } else {
    alert(schoolroutesVehicles.message)
    state.status = 'error'
  }
}
export default {
  SCHOOLROUTES_VEHICLES_ALL,
  SCHOOLROUTES_VEHICLES_FORM,
  SCHOOLROUTES_VEHICLES_SHOW,
  SCHOOLROUTES_VEHICLES_CREATE,
  SCHOOLROUTES_VEHICLES_UPDATE,
  SCHOOLROUTES_VEHICLES_DELETE,
  SCHOOLROUTES_VEHICLES_PERMISS_LIST,
  SCHOOLROUTES_VEHICLES_LIST_CREAR,
  SCHOOLROUTERS_VEHICLES_ALL,
  SCHOOLROUTES_VEHICLES_LIST_BUSCAR,
  SCHOOLROUTES_VEHICLES_LIST_ACTUALIZA
}



// WEBPACK FOOTER //
// ./src/store/modules/schoolroutes/vehicles/mutations.js